import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Keyboard, Moon, Sun, BookOpen, FilePlus2 } from 'lucide-react';
import type { Theme } from '../hooks/useTheme';
import styles from './TopBar.module.css';

interface Props {
  historyCount: number;
  onShortcuts: () => void;
  onHistory?: () => void;
  theme: Theme;
  onToggleTheme: () => void;
  className?: string;
}

export function TopBar({
  historyCount, onShortcuts, onHistory, theme, onToggleTheme, className,
}: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const onInputScreen = location.pathname === '/';
  return (
    <header className={[styles.bar, className].filter(Boolean).join(' ')}>
      <div className={styles.inner}>
        <Link to="/" className={styles.logoLink} aria-label="TheInvestmentAnalyst home">
          <img src="/assets/logo.png" alt="" className={styles.logo} />
          <span className={styles.wordmark}>
            <span className={styles.brand}>
              The<span className={styles.accent}>Investment</span>Analyst
            </span>
            <span className={styles.sublabel}>Sentiment Analysis</span>
          </span>
        </Link>

        <nav className={styles.nav} aria-label="Primary">
          {!onInputScreen && (
            <button
              type="button"
              className={[styles.navItem, styles.newAnalysis].join(' ')}
              onClick={() => navigate('/')}
              title="Start a new analysis"
            >
              <FilePlus2 size={16} strokeWidth={1.5} aria-hidden="true" />
              <span>New analysis</span>
            </button>
          )}
          <button
            type="button"
            className={styles.navItem}
            onClick={() => (onHistory ? onHistory() : navigate('/history'))}
          >
            <BookOpen size={16} strokeWidth={1.5} aria-hidden="true" />
            <span>Library</span>
            {historyCount > 0 && <span className={styles.count}>{historyCount}</span>}
          </button>
          <button type="button" className={styles.navItem} onClick={onShortcuts}>
            <Keyboard size={16} strokeWidth={1.5} aria-hidden="true" />
            <span>Shortcuts</span>
          </button>
          <button
            type="button"
            className={styles.navItem}
            onClick={onToggleTheme}
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {theme === 'dark' ? (
              <Sun size={16} strokeWidth={1.5} aria-hidden="true" />
            ) : (
              <Moon size={16} strokeWidth={1.5} aria-hidden="true" />
            )}
          </button>
        </nav>
      </div>
    </header>
  );
}
